module.exports = __webpack_public_path__ + "static/media/guandao_pic1.54d1fad6.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/guandao_pic1.png
 ** module id = 437
 ** module chunks = 0
 **/